<div style="display: flex;flex-direction:column;height:100%;" class="loginBg">
    <div *ngIf="isIE" class="iebanner">
        Internet Explorer is not fully compatible, recomended to use Chrome/Firefox.
    </div>
    <div class="header">
        <img src="/assets/images/header.png" height="70">
    </div>
    <div id="divLogin" fxFlex="none" fxLayout="column">
        <div style="padding: 25px 50px;border-bottom: 1px solid #e5e5e5;font-size: 18px;">
            <mat-icon>lock</mat-icon> Login
        </div>
        <div fxFlex fxLayout="column" fxLayoutGap="10px" style="padding:25px 30px">
            <div class="control">
                <label>Site</label>
                <input type="text" class="block" #txtSite (keyUp.enter)="txtUsername.focus()" />
            </div>
            <div class="control">
                <label>Username</label>
                <input type="text" class="block" #txtUsername (keyUp.enter)="txtPassword.focus()" />
            </div>
            <div class="control" [hidden]="isRecover">
                <label>Password</label>
                <input type="password" class="block" #txtPassword (keyUp.enter)="login(txtSite.value,txtUsername.value,txtPassword.value);" />
            </div>
        </div>
        <div style="padding: 10px 25px 40px;">
            <button mat-raised-button type="button" (click)="login(txtSite.value, txtUsername.value,txtPassword.value)"  
                style="background-color:#811a1b;color:white;width:100%">
                Login
            </button>
        </div>
    </div>
    <div class="footer">
        <img src="../assets/images/footer.png" style="height:30px" /><br/>
        <span id="footerText">Construction Project Supply Chain Management & Monitoring System v{{version}} | Copyright © {{currentTime | date:'yyyy'}} Echol Tech Pte Ltd. | All Rights Reserved.</span>
    </div>
        <!--
    <div style="flex:0 0 auto;font-size: smaller;background-color:rgba(255,255,255,.7);padding:3px 0 3px 10px;">
        QR ISupply Chain Management & Monitoring System v{{version}} | Copyright © {{currentTime | date:'yyyy'}} Echol Tech Pte Ltd. | All Rights Reserved.
    </div>
-->
</div>